(ns minorodata.data-apps.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.users.model :refer [searchable-user]]))

(declare ->data-app)

(m/defmodel data-app
  {:data-app-id   [::m/identity ::m/req ::m/string "Unique id"]
   :dashboard-url [::m/string ::m/nilable "Sigma dashbaord URL"]})

